import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/twitch-vod-to-shorts")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/twitch-vod-to-shorts", statusCode: 301 })
  },
})
